import styled from 'styled-components';
import Button from '../../components/Button';

export const MoreFiltercontainer = styled.div`
  display: flex;
  align-items: center;

  button {
    background: transparent;
  }
`;

export const DownloadButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #292F36;

  i {
    font-size: 14px;
    height: initial;
  }
`;

export const PDFButton = styled(Button)`
  background-color: rgba(255, 255, 255, 0.3);
`;
